/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Video_AriaInputs */



/**
* | output |
* | --- |
* | "Export video file with burnt-in captions" |
*
* @param {File_Export_Video_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_video_aria = /** @type {((inputs?: File_Export_Video_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Video_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter un fichier video avec sous-titres incrustes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodatei mit eingebetteten Untertiteln exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta file video con sottotitoli incorporati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видеофайла со встроенными субтитрами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar archivo de vídeo con subtítulos incorporados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出带有内嵌字幕的视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("焼き付けキャプション付きのビデオファイルをエクスポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो फ़ाइल को कैप्शन सहित निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar arquivo de vídeo com legendas incorporadas")
	return /** @type {LocalizedString} */ ("Export video file with burnt-in captions")
});